import React from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
const Footer = () => {
  const location = useLocation();

  const socialIcons = [
    // {
    //   img: "/assets/images/footer/linkedin.png",
    //   link: "https://www.linkedin.com",
    // },
    {
      img: "/assets/images/footer/fb.png",
      link: "https://www.facebook.com/people/Tech-Interiors-and-Designers/61581722197336/"
    },
    // { img: "/assets/images/footer/x.png", link: "https://www.twitter.com" },
    {
      img: "/assets/images/footer/insta.png",
      link: "https://www.instagram.com/techinteriors_designers",
    },
  ];

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="logo_holder">
            <Link to="/"><img src="/assets/images/logo/logo.png" className="logo_img" /></Link>
          </div>

          <div className="row">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Useful Links</p>
                <Nav>
                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/"
                        className={location.pathname === "/" ? "active" : ""}
                      >
                        Home
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/about-us"
                        className={
                          location.pathname === "/about-us" ? "active" : ""
                        }
                      >
                        About Us
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/services/furniture-custom-carpentry"
                        className={
                          location.pathname ===
                            "/services/furniture-custom-carpentry"
                            ? "active"
                            : ""
                        }
                      >
                        Services
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/projects"
                        className={
                          location.pathname === "/projects" ? "active" : ""
                        }
                      >
                        Projects
                      </NavLink>
                    </Nav.Item>
                  </div>

                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/contact-us"
                        className={
                          location.pathname === "/contact-us" ? "active" : ""
                        }
                      >
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/privacy-policy"
                        className={
                          location.pathname === "/privacy-policy"
                            ? "active"
                            : ""
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/terms-conditions"
                        className={
                          location.pathname === "/terms-conditions"
                            ? "active"
                            : ""
                        }
                      >
                        Terms & Conditions
                      </NavLink>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <NavLink as={Link} to="/faq">
                        FAQs
                      </NavLink>
                    </Nav.Item> */}
                  </div>
                </Nav>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Reach Us at</p>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faLocationDot} className="icon_text" />
                  <p className="info_text">
                    Pune, Maharashtra
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Contact Us</p>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faPhone} className="icon_text" />
                  <div className="no_div">
                    {/* <p className="info_text">9767297324 / 9665441753</p> */}
                    <a href="tel:9767297324" className="no_inner_text">9767297324</a>/ <a className="no_inner_text" href="tel:9665441753">9665441753</a>
                  </div>
                </div>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faEnvelope} className="icon_text" />
                  {/* <p className="info_text">info@techinteriors.com</p> */}

                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=techinteriorsanddesigners@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="info_text">techinteriorsanddesigners@gmail.com</p>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-2 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Social Links</p>

                <div className="icons_holder">
                  {socialIcons.map((item, index) => (
                    <div className="img_holder">
                      <a
                        key={index}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="img_holder"
                      >
                        <img
                          src={item.img}
                          alt={`social-icon-${index}`}
                          className="icon_img"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              © 2025 TECH Interiors & Designeres All Rights Reserved | Developed
              by{" "}
              <Link
                target="_blank"
                className="link_text"
                to="https://profcymaglobal.com/"
              >
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
